export default [
    {
      path: '/admin/product-histories',
      name: 'product-history',
      meta: { requiresAuth: true },
      component: () => import('@/pages/product/history/index.vue')
    }
  ]